import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, ContentChildren, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';
import { PROPERTY_TOKEN_annotations, PROPERTY_TOKEN_breaks, PROPERTY_TOKEN_constantLines, PROPERTY_TOKEN_strips, PROPERTY_TOKEN_panes, PROPERTY_TOKEN_series, PROPERTY_TOKEN_valueAxis } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoChartAdaptiveLayoutComponent = /*#__PURE__*/(() => {
  class DxoChartAdaptiveLayoutComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get keepLabels() {
      return this._getOption('keepLabels');
    }
    set keepLabels(value) {
      this._setOption('keepLabels', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'adaptiveLayout';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAdaptiveLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAdaptiveLayoutComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAdaptiveLayoutComponent,
      selectors: [["dxo-chart-adaptive-layout"]],
      inputs: {
        height: "height",
        keepLabels: "keepLabels",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAdaptiveLayoutComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAdaptiveLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAdaptiveLayoutModule = /*#__PURE__*/(() => {
  class DxoChartAdaptiveLayoutModule {
    /** @nocollapse */static ɵfac = function DxoChartAdaptiveLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAdaptiveLayoutModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAdaptiveLayoutModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAdaptiveLayoutComponent]
    });
  }
  return DxoChartAdaptiveLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAggregationIntervalComponent = /*#__PURE__*/(() => {
  class DxoChartAggregationIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'aggregationInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAggregationIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAggregationIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAggregationIntervalComponent,
      selectors: [["dxo-chart-aggregation-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAggregationIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAggregationIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAggregationIntervalModule = /*#__PURE__*/(() => {
  class DxoChartAggregationIntervalModule {
    /** @nocollapse */static ɵfac = function DxoChartAggregationIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAggregationIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAggregationIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAggregationIntervalComponent]
    });
  }
  return DxoChartAggregationIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAggregationComponent = /*#__PURE__*/(() => {
  class DxoChartAggregationComponent extends NestedOption {
    get calculate() {
      return this._getOption('calculate');
    }
    set calculate(value) {
      this._setOption('calculate', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get method() {
      return this._getOption('method');
    }
    set method(value) {
      this._setOption('method', value);
    }
    get _optionPath() {
      return 'aggregation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAggregationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAggregationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAggregationComponent,
      selectors: [["dxo-chart-aggregation"]],
      inputs: {
        calculate: "calculate",
        enabled: "enabled",
        method: "method"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAggregationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAggregationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAggregationModule = /*#__PURE__*/(() => {
  class DxoChartAggregationModule {
    /** @nocollapse */static ɵfac = function DxoChartAggregationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAggregationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAggregationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAggregationComponent]
    });
  }
  return DxoChartAggregationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAnimationComponent = /*#__PURE__*/(() => {
  class DxoChartAnimationComponent extends NestedOption {
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get maxPointCountSupported() {
      return this._getOption('maxPointCountSupported');
    }
    set maxPointCountSupported(value) {
      this._setOption('maxPointCountSupported', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAnimationComponent,
      selectors: [["dxo-chart-animation"]],
      inputs: {
        duration: "duration",
        easing: "easing",
        enabled: "enabled",
        maxPointCountSupported: "maxPointCountSupported"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAnimationModule = /*#__PURE__*/(() => {
  class DxoChartAnimationModule {
    /** @nocollapse */static ɵfac = function DxoChartAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAnimationComponent]
    });
  }
  return DxoChartAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAnnotationBorderComponent = /*#__PURE__*/(() => {
  class DxoChartAnnotationBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAnnotationBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAnnotationBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAnnotationBorderComponent,
      selectors: [["dxo-chart-annotation-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAnnotationBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAnnotationBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAnnotationBorderModule = /*#__PURE__*/(() => {
  class DxoChartAnnotationBorderModule {
    /** @nocollapse */static ɵfac = function DxoChartAnnotationBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAnnotationBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAnnotationBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAnnotationBorderComponent]
    });
  }
  return DxoChartAnnotationBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartAnnotationComponent = /*#__PURE__*/(() => {
  class DxiChartAnnotationComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'annotations';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartAnnotationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartAnnotationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartAnnotationComponent,
      selectors: [["dxi-chart-annotation"]],
      inputs: {
        allowDragging: "allowDragging",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        axis: "axis",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        name: "name",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        value: "value",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_annotations,
        useExisting: DxiChartAnnotationComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiChartAnnotationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiChartAnnotationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartAnnotationModule = /*#__PURE__*/(() => {
  class DxiChartAnnotationModule {
    /** @nocollapse */static ɵfac = function DxiChartAnnotationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartAnnotationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartAnnotationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartAnnotationComponent]
    });
  }
  return DxiChartAnnotationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAnnotationImageComponent = /*#__PURE__*/(() => {
  class DxoChartAnnotationImageComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'image';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAnnotationImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAnnotationImageComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAnnotationImageComponent,
      selectors: [["dxo-chart-annotation-image"]],
      inputs: {
        height: "height",
        url: "url",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAnnotationImageComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAnnotationImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAnnotationImageModule = /*#__PURE__*/(() => {
  class DxoChartAnnotationImageModule {
    /** @nocollapse */static ɵfac = function DxoChartAnnotationImageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAnnotationImageModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAnnotationImageModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAnnotationImageComponent]
    });
  }
  return DxoChartAnnotationImageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartArgumentAxisComponent = /*#__PURE__*/(() => {
  class DxoChartArgumentAxisComponent extends NestedOption {
    set _breaksContentChildren(value) {
      this.setChildren('breaks', value);
    }
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get aggregatedPointsPosition() {
      return this._getOption('aggregatedPointsPosition');
    }
    set aggregatedPointsPosition(value) {
      this._setOption('aggregatedPointsPosition', value);
    }
    get aggregationGroupWidth() {
      return this._getOption('aggregationGroupWidth');
    }
    set aggregationGroupWidth(value) {
      this._setOption('aggregationGroupWidth', value);
    }
    get aggregationInterval() {
      return this._getOption('aggregationInterval');
    }
    set aggregationInterval(value) {
      this._setOption('aggregationInterval', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get breaks() {
      return this._getOption('breaks');
    }
    set breaks(value) {
      this._setOption('breaks', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get customPosition() {
      return this._getOption('customPosition');
    }
    set customPosition(value) {
      this._setOption('customPosition', value);
    }
    get customPositionAxis() {
      return this._getOption('customPositionAxis');
    }
    set customPositionAxis(value) {
      this._setOption('customPositionAxis', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get holidays() {
      return this._getOption('holidays');
    }
    set holidays(value) {
      this._setOption('holidays', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get minVisualRangeLength() {
      return this._getOption('minVisualRangeLength');
    }
    set minVisualRangeLength(value) {
      this._setOption('minVisualRangeLength', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get singleWorkdays() {
      return this._getOption('singleWorkdays');
    }
    set singleWorkdays(value) {
      this._setOption('singleWorkdays', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visualRange() {
      return this._getOption('visualRange');
    }
    set visualRange(value) {
      this._setOption('visualRange', value);
    }
    get visualRangeUpdateMode() {
      return this._getOption('visualRangeUpdateMode');
    }
    set visualRangeUpdateMode(value) {
      this._setOption('visualRangeUpdateMode', value);
    }
    get wholeRange() {
      return this._getOption('wholeRange');
    }
    set wholeRange(value) {
      this._setOption('wholeRange', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get workdaysOnly() {
      return this._getOption('workdaysOnly');
    }
    set workdaysOnly(value) {
      this._setOption('workdaysOnly', value);
    }
    get workWeek() {
      return this._getOption('workWeek');
    }
    set workWeek(value) {
      this._setOption('workWeek', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    categoriesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visualRangeChange;
    get _optionPath() {
      return 'argumentAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'categoriesChange'
      }, {
        emit: 'visualRangeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartArgumentAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartArgumentAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartArgumentAxisComponent,
      selectors: [["dxo-chart-argument-axis"]],
      contentQueries: function DxoChartArgumentAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_breaks, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._breaksContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        aggregatedPointsPosition: "aggregatedPointsPosition",
        aggregationGroupWidth: "aggregationGroupWidth",
        aggregationInterval: "aggregationInterval",
        allowDecimals: "allowDecimals",
        argumentType: "argumentType",
        axisDivisionFactor: "axisDivisionFactor",
        breaks: "breaks",
        breakStyle: "breakStyle",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        customPosition: "customPosition",
        customPositionAxis: "customPositionAxis",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        holidays: "holidays",
        hoverMode: "hoverMode",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        minValueMargin: "minValueMargin",
        minVisualRangeLength: "minVisualRangeLength",
        offset: "offset",
        opacity: "opacity",
        placeholderSize: "placeholderSize",
        position: "position",
        singleWorkdays: "singleWorkdays",
        strips: "strips",
        stripStyle: "stripStyle",
        tick: "tick",
        tickInterval: "tickInterval",
        title: "title",
        type: "type",
        valueMarginsEnabled: "valueMarginsEnabled",
        visible: "visible",
        visualRange: "visualRange",
        visualRangeUpdateMode: "visualRangeUpdateMode",
        wholeRange: "wholeRange",
        width: "width",
        workdaysOnly: "workdaysOnly",
        workWeek: "workWeek"
      },
      outputs: {
        categoriesChange: "categoriesChange",
        visualRangeChange: "visualRangeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartArgumentAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartArgumentAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartArgumentAxisModule = /*#__PURE__*/(() => {
  class DxoChartArgumentAxisModule {
    /** @nocollapse */static ɵfac = function DxoChartArgumentAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartArgumentAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartArgumentAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartArgumentAxisComponent]
    });
  }
  return DxoChartArgumentAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartArgumentFormatComponent = /*#__PURE__*/(() => {
  class DxoChartArgumentFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'argumentFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartArgumentFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartArgumentFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartArgumentFormatComponent,
      selectors: [["dxo-chart-argument-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartArgumentFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartArgumentFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartArgumentFormatModule = /*#__PURE__*/(() => {
  class DxoChartArgumentFormatModule {
    /** @nocollapse */static ɵfac = function DxoChartArgumentFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartArgumentFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartArgumentFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartArgumentFormatComponent]
    });
  }
  return DxoChartArgumentFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAxisConstantLineStyleLabelComponent = /*#__PURE__*/(() => {
  class DxoChartAxisConstantLineStyleLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAxisConstantLineStyleLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisConstantLineStyleLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAxisConstantLineStyleLabelComponent,
      selectors: [["dxo-chart-axis-constant-line-style-label"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        position: "position",
        verticalAlignment: "verticalAlignment",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAxisConstantLineStyleLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAxisConstantLineStyleLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAxisConstantLineStyleLabelModule = /*#__PURE__*/(() => {
  class DxoChartAxisConstantLineStyleLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartAxisConstantLineStyleLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisConstantLineStyleLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAxisConstantLineStyleLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAxisConstantLineStyleLabelComponent]
    });
  }
  return DxoChartAxisConstantLineStyleLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAxisConstantLineStyleComponent = /*#__PURE__*/(() => {
  class DxoChartAxisConstantLineStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLineStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAxisConstantLineStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisConstantLineStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAxisConstantLineStyleComponent,
      selectors: [["dxo-chart-axis-constant-line-style"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAxisConstantLineStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAxisConstantLineStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAxisConstantLineStyleModule = /*#__PURE__*/(() => {
  class DxoChartAxisConstantLineStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartAxisConstantLineStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisConstantLineStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAxisConstantLineStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAxisConstantLineStyleComponent]
    });
  }
  return DxoChartAxisConstantLineStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAxisLabelComponent = /*#__PURE__*/(() => {
  class DxoChartAxisLabelComponent extends NestedOption {
    renderer;
    document;
    element;
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get staggeringSpacing() {
      return this._getOption('staggeringSpacing');
    }
    set staggeringSpacing(value) {
      this._setOption('staggeringSpacing', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAxisLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAxisLabelComponent,
      selectors: [["dxo-chart-axis-label"]],
      inputs: {
        alignment: "alignment",
        customizeHint: "customizeHint",
        customizeText: "customizeText",
        displayMode: "displayMode",
        font: "font",
        format: "format",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        position: "position",
        rotationAngle: "rotationAngle",
        staggeringSpacing: "staggeringSpacing",
        template: "template",
        textOverflow: "textOverflow",
        visible: "visible",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoChartAxisLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoChartAxisLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAxisLabelModule = /*#__PURE__*/(() => {
  class DxoChartAxisLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartAxisLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAxisLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAxisLabelComponent]
    });
  }
  return DxoChartAxisLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartAxisTitleComponent = /*#__PURE__*/(() => {
  class DxoChartAxisTitleComponent extends NestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartAxisTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartAxisTitleComponent,
      selectors: [["dxo-chart-axis-title"]],
      inputs: {
        alignment: "alignment",
        font: "font",
        margin: "margin",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartAxisTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartAxisTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartAxisTitleModule = /*#__PURE__*/(() => {
  class DxoChartAxisTitleModule {
    /** @nocollapse */static ɵfac = function DxoChartAxisTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartAxisTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartAxisTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartAxisTitleComponent]
    });
  }
  return DxoChartAxisTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartBackgroundColorComponent = /*#__PURE__*/(() => {
  class DxoChartBackgroundColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'backgroundColor';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartBackgroundColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartBackgroundColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartBackgroundColorComponent,
      selectors: [["dxo-chart-background-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartBackgroundColorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartBackgroundColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartBackgroundColorModule = /*#__PURE__*/(() => {
  class DxoChartBackgroundColorModule {
    /** @nocollapse */static ɵfac = function DxoChartBackgroundColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartBackgroundColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartBackgroundColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartBackgroundColorComponent]
    });
  }
  return DxoChartBackgroundColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartBorderComponent = /*#__PURE__*/(() => {
  class DxoChartBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartBorderComponent,
      selectors: [["dxo-chart-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width",
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartBorderModule = /*#__PURE__*/(() => {
  class DxoChartBorderModule {
    /** @nocollapse */static ɵfac = function DxoChartBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartBorderComponent]
    });
  }
  return DxoChartBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartBreakComponent = /*#__PURE__*/(() => {
  class DxiChartBreakComponent extends CollectionNestedOption {
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'breaks';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartBreakComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartBreakComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartBreakComponent,
      selectors: [["dxi-chart-break"]],
      inputs: {
        endValue: "endValue",
        startValue: "startValue"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_breaks,
        useExisting: DxiChartBreakComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartBreakComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChartBreakComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartBreakModule = /*#__PURE__*/(() => {
  class DxiChartBreakModule {
    /** @nocollapse */static ɵfac = function DxiChartBreakModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartBreakModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartBreakModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartBreakComponent]
    });
  }
  return DxiChartBreakModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartBreakStyleComponent = /*#__PURE__*/(() => {
  class DxoChartBreakStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get line() {
      return this._getOption('line');
    }
    set line(value) {
      this._setOption('line', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'breakStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartBreakStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartBreakStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartBreakStyleComponent,
      selectors: [["dxo-chart-break-style"]],
      inputs: {
        color: "color",
        line: "line",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartBreakStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartBreakStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartBreakStyleModule = /*#__PURE__*/(() => {
  class DxoChartBreakStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartBreakStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartBreakStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartBreakStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartBreakStyleComponent]
    });
  }
  return DxoChartBreakStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartChartTitleSubtitleComponent = /*#__PURE__*/(() => {
  class DxoChartChartTitleSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartChartTitleSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartChartTitleSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartChartTitleSubtitleComponent,
      selectors: [["dxo-chart-chart-title-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartChartTitleSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartChartTitleSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartChartTitleSubtitleModule = /*#__PURE__*/(() => {
  class DxoChartChartTitleSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoChartChartTitleSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartChartTitleSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartChartTitleSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartChartTitleSubtitleComponent]
    });
  }
  return DxoChartChartTitleSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartChartTitleComponent = /*#__PURE__*/(() => {
  class DxoChartChartTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartChartTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartChartTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartChartTitleComponent,
      selectors: [["dxo-chart-chart-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        textOverflow: "textOverflow",
        verticalAlignment: "verticalAlignment",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartChartTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartChartTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartChartTitleModule = /*#__PURE__*/(() => {
  class DxoChartChartTitleModule {
    /** @nocollapse */static ɵfac = function DxoChartChartTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartChartTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartChartTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartChartTitleComponent]
    });
  }
  return DxoChartChartTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartColorComponent = /*#__PURE__*/(() => {
  class DxoChartColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'color';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartColorComponent,
      selectors: [["dxo-chart-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartColorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartColorModule = /*#__PURE__*/(() => {
  class DxoChartColorModule {
    /** @nocollapse */static ɵfac = function DxoChartColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartColorComponent]
    });
  }
  return DxoChartColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAnnotationSettingsComponent = /*#__PURE__*/(() => {
  class DxoChartCommonAnnotationSettingsComponent extends NestedOption {
    renderer;
    document;
    element;
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'commonAnnotationSettings';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonAnnotationSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAnnotationSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAnnotationSettingsComponent,
      selectors: [["dxo-chart-common-annotation-settings"]],
      inputs: {
        allowDragging: "allowDragging",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        axis: "axis",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        value: "value",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoChartCommonAnnotationSettingsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoChartCommonAnnotationSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonAnnotationSettingsModule = /*#__PURE__*/(() => {
  class DxoChartCommonAnnotationSettingsModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonAnnotationSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAnnotationSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonAnnotationSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonAnnotationSettingsComponent]
    });
  }
  return DxoChartCommonAnnotationSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAxisSettingsConstantLineStyleLabelComponent = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsConstantLineStyleLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonAxisSettingsConstantLineStyleLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsConstantLineStyleLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAxisSettingsConstantLineStyleLabelComponent,
      selectors: [["dxo-chart-common-axis-settings-constant-line-style-label"]],
      inputs: {
        font: "font",
        position: "position",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonAxisSettingsConstantLineStyleLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonAxisSettingsConstantLineStyleLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonAxisSettingsConstantLineStyleLabelModule = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsConstantLineStyleLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonAxisSettingsConstantLineStyleLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsConstantLineStyleLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonAxisSettingsConstantLineStyleLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonAxisSettingsConstantLineStyleLabelComponent]
    });
  }
  return DxoChartCommonAxisSettingsConstantLineStyleLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAxisSettingsConstantLineStyleComponent = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsConstantLineStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLineStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonAxisSettingsConstantLineStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsConstantLineStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAxisSettingsConstantLineStyleComponent,
      selectors: [["dxo-chart-common-axis-settings-constant-line-style"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonAxisSettingsConstantLineStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonAxisSettingsConstantLineStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonAxisSettingsConstantLineStyleModule = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsConstantLineStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonAxisSettingsConstantLineStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsConstantLineStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonAxisSettingsConstantLineStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonAxisSettingsConstantLineStyleComponent]
    });
  }
  return DxoChartCommonAxisSettingsConstantLineStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAxisSettingsLabelComponent = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsLabelComponent extends NestedOption {
    renderer;
    document;
    element;
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get staggeringSpacing() {
      return this._getOption('staggeringSpacing');
    }
    set staggeringSpacing(value) {
      this._setOption('staggeringSpacing', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonAxisSettingsLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAxisSettingsLabelComponent,
      selectors: [["dxo-chart-common-axis-settings-label"]],
      inputs: {
        alignment: "alignment",
        displayMode: "displayMode",
        font: "font",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        position: "position",
        rotationAngle: "rotationAngle",
        staggeringSpacing: "staggeringSpacing",
        template: "template",
        textOverflow: "textOverflow",
        visible: "visible",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoChartCommonAxisSettingsLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoChartCommonAxisSettingsLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonAxisSettingsLabelModule = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonAxisSettingsLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonAxisSettingsLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonAxisSettingsLabelComponent]
    });
  }
  return DxoChartCommonAxisSettingsLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAxisSettingsTitleComponent = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsTitleComponent extends NestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonAxisSettingsTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAxisSettingsTitleComponent,
      selectors: [["dxo-chart-common-axis-settings-title"]],
      inputs: {
        alignment: "alignment",
        font: "font",
        margin: "margin",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonAxisSettingsTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonAxisSettingsTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonAxisSettingsTitleModule = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsTitleModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonAxisSettingsTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonAxisSettingsTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonAxisSettingsTitleComponent]
    });
  }
  return DxoChartCommonAxisSettingsTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAxisSettingsComponent = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsComponent extends NestedOption {
    get aggregatedPointsPosition() {
      return this._getOption('aggregatedPointsPosition');
    }
    set aggregatedPointsPosition(value) {
      this._setOption('aggregatedPointsPosition', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'commonAxisSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonAxisSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAxisSettingsComponent,
      selectors: [["dxo-chart-common-axis-settings"]],
      inputs: {
        aggregatedPointsPosition: "aggregatedPointsPosition",
        allowDecimals: "allowDecimals",
        breakStyle: "breakStyle",
        color: "color",
        constantLineStyle: "constantLineStyle",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minValueMargin: "minValueMargin",
        opacity: "opacity",
        placeholderSize: "placeholderSize",
        stripStyle: "stripStyle",
        tick: "tick",
        title: "title",
        valueMarginsEnabled: "valueMarginsEnabled",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonAxisSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonAxisSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonAxisSettingsModule = /*#__PURE__*/(() => {
  class DxoChartCommonAxisSettingsModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonAxisSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonAxisSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonAxisSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonAxisSettingsComponent]
    });
  }
  return DxoChartCommonAxisSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonPaneSettingsComponent = /*#__PURE__*/(() => {
  class DxoChartCommonPaneSettingsComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get _optionPath() {
      return 'commonPaneSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonPaneSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonPaneSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonPaneSettingsComponent,
      selectors: [["dxo-chart-common-pane-settings"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonPaneSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonPaneSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonPaneSettingsModule = /*#__PURE__*/(() => {
  class DxoChartCommonPaneSettingsModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonPaneSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonPaneSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonPaneSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonPaneSettingsComponent]
    });
  }
  return DxoChartCommonPaneSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonSeriesSettingsHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonSeriesSettingsHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonSeriesSettingsHoverStyleComponent,
      selectors: [["dxo-chart-common-series-settings-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonSeriesSettingsHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonSeriesSettingsHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonSeriesSettingsHoverStyleModule = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonSeriesSettingsHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonSeriesSettingsHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonSeriesSettingsHoverStyleComponent]
    });
  }
  return DxoChartCommonSeriesSettingsHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonSeriesSettingsLabelComponent = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsLabelComponent extends NestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get connector() {
      return this._getOption('connector');
    }
    set connector(value) {
      this._setOption('connector', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get horizontalOffset() {
      return this._getOption('horizontalOffset');
    }
    set horizontalOffset(value) {
      this._setOption('horizontalOffset', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get showForZeroValues() {
      return this._getOption('showForZeroValues');
    }
    set showForZeroValues(value) {
      this._setOption('showForZeroValues', value);
    }
    get verticalOffset() {
      return this._getOption('verticalOffset');
    }
    set verticalOffset(value) {
      this._setOption('verticalOffset', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonSeriesSettingsLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonSeriesSettingsLabelComponent,
      selectors: [["dxo-chart-common-series-settings-label"]],
      inputs: {
        alignment: "alignment",
        argumentFormat: "argumentFormat",
        backgroundColor: "backgroundColor",
        border: "border",
        connector: "connector",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        font: "font",
        format: "format",
        horizontalOffset: "horizontalOffset",
        position: "position",
        rotationAngle: "rotationAngle",
        showForZeroValues: "showForZeroValues",
        verticalOffset: "verticalOffset",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonSeriesSettingsLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonSeriesSettingsLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonSeriesSettingsLabelModule = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonSeriesSettingsLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonSeriesSettingsLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonSeriesSettingsLabelComponent]
    });
  }
  return DxoChartCommonSeriesSettingsLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonSeriesSettingsSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonSeriesSettingsSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonSeriesSettingsSelectionStyleComponent,
      selectors: [["dxo-chart-common-series-settings-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonSeriesSettingsSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonSeriesSettingsSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonSeriesSettingsSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonSeriesSettingsSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonSeriesSettingsSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonSeriesSettingsSelectionStyleComponent]
    });
  }
  return DxoChartCommonSeriesSettingsSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonSeriesSettingsComponent = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsComponent extends NestedOption {
    get aggregation() {
      return this._getOption('aggregation');
    }
    set aggregation(value) {
      this._setOption('aggregation', value);
    }
    get area() {
      return this._getOption('area');
    }
    set area(value) {
      this._setOption('area', value);
    }
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get bar() {
      return this._getOption('bar');
    }
    set bar(value) {
      this._setOption('bar', value);
    }
    get barOverlapGroup() {
      return this._getOption('barOverlapGroup');
    }
    set barOverlapGroup(value) {
      this._setOption('barOverlapGroup', value);
    }
    get barPadding() {
      return this._getOption('barPadding');
    }
    set barPadding(value) {
      this._setOption('barPadding', value);
    }
    get barWidth() {
      return this._getOption('barWidth');
    }
    set barWidth(value) {
      this._setOption('barWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get bubble() {
      return this._getOption('bubble');
    }
    set bubble(value) {
      this._setOption('bubble', value);
    }
    get candlestick() {
      return this._getOption('candlestick');
    }
    set candlestick(value) {
      this._setOption('candlestick', value);
    }
    get closeValueField() {
      return this._getOption('closeValueField');
    }
    set closeValueField(value) {
      this._setOption('closeValueField', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get fullstackedarea() {
      return this._getOption('fullstackedarea');
    }
    set fullstackedarea(value) {
      this._setOption('fullstackedarea', value);
    }
    get fullstackedbar() {
      return this._getOption('fullstackedbar');
    }
    set fullstackedbar(value) {
      this._setOption('fullstackedbar', value);
    }
    get fullstackedline() {
      return this._getOption('fullstackedline');
    }
    set fullstackedline(value) {
      this._setOption('fullstackedline', value);
    }
    get fullstackedspline() {
      return this._getOption('fullstackedspline');
    }
    set fullstackedspline(value) {
      this._setOption('fullstackedspline', value);
    }
    get fullstackedsplinearea() {
      return this._getOption('fullstackedsplinearea');
    }
    set fullstackedsplinearea(value) {
      this._setOption('fullstackedsplinearea', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get ignoreEmptyPoints() {
      return this._getOption('ignoreEmptyPoints');
    }
    set ignoreEmptyPoints(value) {
      this._setOption('ignoreEmptyPoints', value);
    }
    get innerColor() {
      return this._getOption('innerColor');
    }
    set innerColor(value) {
      this._setOption('innerColor', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get line() {
      return this._getOption('line');
    }
    set line(value) {
      this._setOption('line', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minBarSize() {
      return this._getOption('minBarSize');
    }
    set minBarSize(value) {
      this._setOption('minBarSize', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get openValueField() {
      return this._getOption('openValueField');
    }
    set openValueField(value) {
      this._setOption('openValueField', value);
    }
    get pane() {
      return this._getOption('pane');
    }
    set pane(value) {
      this._setOption('pane', value);
    }
    get point() {
      return this._getOption('point');
    }
    set point(value) {
      this._setOption('point', value);
    }
    get rangearea() {
      return this._getOption('rangearea');
    }
    set rangearea(value) {
      this._setOption('rangearea', value);
    }
    get rangebar() {
      return this._getOption('rangebar');
    }
    set rangebar(value) {
      this._setOption('rangebar', value);
    }
    get rangeValue1Field() {
      return this._getOption('rangeValue1Field');
    }
    set rangeValue1Field(value) {
      this._setOption('rangeValue1Field', value);
    }
    get rangeValue2Field() {
      return this._getOption('rangeValue2Field');
    }
    set rangeValue2Field(value) {
      this._setOption('rangeValue2Field', value);
    }
    get reduction() {
      return this._getOption('reduction');
    }
    set reduction(value) {
      this._setOption('reduction', value);
    }
    get scatter() {
      return this._getOption('scatter');
    }
    set scatter(value) {
      this._setOption('scatter', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get showInLegend() {
      return this._getOption('showInLegend');
    }
    set showInLegend(value) {
      this._setOption('showInLegend', value);
    }
    get sizeField() {
      return this._getOption('sizeField');
    }
    set sizeField(value) {
      this._setOption('sizeField', value);
    }
    get spline() {
      return this._getOption('spline');
    }
    set spline(value) {
      this._setOption('spline', value);
    }
    get splinearea() {
      return this._getOption('splinearea');
    }
    set splinearea(value) {
      this._setOption('splinearea', value);
    }
    get stack() {
      return this._getOption('stack');
    }
    set stack(value) {
      this._setOption('stack', value);
    }
    get stackedarea() {
      return this._getOption('stackedarea');
    }
    set stackedarea(value) {
      this._setOption('stackedarea', value);
    }
    get stackedbar() {
      return this._getOption('stackedbar');
    }
    set stackedbar(value) {
      this._setOption('stackedbar', value);
    }
    get stackedline() {
      return this._getOption('stackedline');
    }
    set stackedline(value) {
      this._setOption('stackedline', value);
    }
    get stackedspline() {
      return this._getOption('stackedspline');
    }
    set stackedspline(value) {
      this._setOption('stackedspline', value);
    }
    get stackedsplinearea() {
      return this._getOption('stackedsplinearea');
    }
    set stackedsplinearea(value) {
      this._setOption('stackedsplinearea', value);
    }
    get steparea() {
      return this._getOption('steparea');
    }
    set steparea(value) {
      this._setOption('steparea', value);
    }
    get stepline() {
      return this._getOption('stepline');
    }
    set stepline(value) {
      this._setOption('stepline', value);
    }
    get stock() {
      return this._getOption('stock');
    }
    set stock(value) {
      this._setOption('stock', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueErrorBar() {
      return this._getOption('valueErrorBar');
    }
    set valueErrorBar(value) {
      this._setOption('valueErrorBar', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'commonSeriesSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCommonSeriesSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonSeriesSettingsComponent,
      selectors: [["dxo-chart-common-series-settings"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonSeriesSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCommonSeriesSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCommonSeriesSettingsModule = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettingsModule {
    /** @nocollapse */static ɵfac = function DxoChartCommonSeriesSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCommonSeriesSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCommonSeriesSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCommonSeriesSettingsComponent]
    });
  }
  return DxoChartCommonSeriesSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartConnectorComponent = /*#__PURE__*/(() => {
  class DxoChartConnectorComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'connector';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartConnectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartConnectorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartConnectorComponent,
      selectors: [["dxo-chart-connector"]],
      inputs: {
        color: "color",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartConnectorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartConnectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartConnectorModule = /*#__PURE__*/(() => {
  class DxoChartConnectorModule {
    /** @nocollapse */static ɵfac = function DxoChartConnectorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartConnectorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartConnectorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartConnectorComponent]
    });
  }
  return DxoChartConnectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartConstantLineComponent = /*#__PURE__*/(() => {
  class DxiChartConstantLineComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get displayBehindSeries() {
      return this._getOption('displayBehindSeries');
    }
    set displayBehindSeries(value) {
      this._setOption('displayBehindSeries', value);
    }
    get extendAxis() {
      return this._getOption('extendAxis');
    }
    set extendAxis(value) {
      this._setOption('extendAxis', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLines';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartConstantLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartConstantLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartConstantLineComponent,
      selectors: [["dxi-chart-constant-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        displayBehindSeries: "displayBehindSeries",
        extendAxis: "extendAxis",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        value: "value",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_constantLines,
        useExisting: DxiChartConstantLineComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartConstantLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChartConstantLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartConstantLineModule = /*#__PURE__*/(() => {
  class DxiChartConstantLineModule {
    /** @nocollapse */static ɵfac = function DxiChartConstantLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartConstantLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartConstantLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartConstantLineComponent]
    });
  }
  return DxiChartConstantLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartConstantLineLabelComponent = /*#__PURE__*/(() => {
  class DxoChartConstantLineLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartConstantLineLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartConstantLineLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartConstantLineLabelComponent,
      selectors: [["dxo-chart-constant-line-label"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        position: "position",
        text: "text",
        verticalAlignment: "verticalAlignment",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartConstantLineLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartConstantLineLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartConstantLineLabelModule = /*#__PURE__*/(() => {
  class DxoChartConstantLineLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartConstantLineLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartConstantLineLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartConstantLineLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartConstantLineLabelComponent]
    });
  }
  return DxoChartConstantLineLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartConstantLineStyleComponent = /*#__PURE__*/(() => {
  class DxoChartConstantLineStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLineStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartConstantLineStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartConstantLineStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartConstantLineStyleComponent,
      selectors: [["dxo-chart-constant-line-style"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartConstantLineStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartConstantLineStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartConstantLineStyleModule = /*#__PURE__*/(() => {
  class DxoChartConstantLineStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartConstantLineStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartConstantLineStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartConstantLineStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartConstantLineStyleComponent]
    });
  }
  return DxoChartConstantLineStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCrosshairComponent = /*#__PURE__*/(() => {
  class DxoChartCrosshairComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get horizontalLine() {
      return this._getOption('horizontalLine');
    }
    set horizontalLine(value) {
      this._setOption('horizontalLine', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get verticalLine() {
      return this._getOption('verticalLine');
    }
    set verticalLine(value) {
      this._setOption('verticalLine', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'crosshair';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartCrosshairComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCrosshairComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCrosshairComponent,
      selectors: [["dxo-chart-crosshair"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        enabled: "enabled",
        horizontalLine: "horizontalLine",
        label: "label",
        opacity: "opacity",
        verticalLine: "verticalLine",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCrosshairComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartCrosshairComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartCrosshairModule = /*#__PURE__*/(() => {
  class DxoChartCrosshairModule {
    /** @nocollapse */static ɵfac = function DxoChartCrosshairModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartCrosshairModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartCrosshairModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartCrosshairComponent]
    });
  }
  return DxoChartCrosshairModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartDataPrepareSettingsComponent = /*#__PURE__*/(() => {
  class DxoChartDataPrepareSettingsComponent extends NestedOption {
    get checkTypeForAllData() {
      return this._getOption('checkTypeForAllData');
    }
    set checkTypeForAllData(value) {
      this._setOption('checkTypeForAllData', value);
    }
    get convertToAxisDataType() {
      return this._getOption('convertToAxisDataType');
    }
    set convertToAxisDataType(value) {
      this._setOption('convertToAxisDataType', value);
    }
    get sortingMethod() {
      return this._getOption('sortingMethod');
    }
    set sortingMethod(value) {
      this._setOption('sortingMethod', value);
    }
    get _optionPath() {
      return 'dataPrepareSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartDataPrepareSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartDataPrepareSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartDataPrepareSettingsComponent,
      selectors: [["dxo-chart-data-prepare-settings"]],
      inputs: {
        checkTypeForAllData: "checkTypeForAllData",
        convertToAxisDataType: "convertToAxisDataType",
        sortingMethod: "sortingMethod"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartDataPrepareSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartDataPrepareSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartDataPrepareSettingsModule = /*#__PURE__*/(() => {
  class DxoChartDataPrepareSettingsModule {
    /** @nocollapse */static ɵfac = function DxoChartDataPrepareSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartDataPrepareSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartDataPrepareSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartDataPrepareSettingsComponent]
    });
  }
  return DxoChartDataPrepareSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartDragBoxStyleComponent = /*#__PURE__*/(() => {
  class DxoChartDragBoxStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'dragBoxStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartDragBoxStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartDragBoxStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartDragBoxStyleComponent,
      selectors: [["dxo-chart-drag-box-style"]],
      inputs: {
        color: "color",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartDragBoxStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartDragBoxStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartDragBoxStyleModule = /*#__PURE__*/(() => {
  class DxoChartDragBoxStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartDragBoxStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartDragBoxStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartDragBoxStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartDragBoxStyleComponent]
    });
  }
  return DxoChartDragBoxStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartExportComponent = /*#__PURE__*/(() => {
  class DxoChartExportComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get printingEnabled() {
      return this._getOption('printingEnabled');
    }
    set printingEnabled(value) {
      this._setOption('printingEnabled', value);
    }
    get svgToCanvas() {
      return this._getOption('svgToCanvas');
    }
    set svgToCanvas(value) {
      this._setOption('svgToCanvas', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartExportComponent,
      selectors: [["dxo-chart-export"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        fileName: "fileName",
        formats: "formats",
        margin: "margin",
        printingEnabled: "printingEnabled",
        svgToCanvas: "svgToCanvas"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartExportComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartExportModule = /*#__PURE__*/(() => {
  class DxoChartExportModule {
    /** @nocollapse */static ɵfac = function DxoChartExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartExportComponent]
    });
  }
  return DxoChartExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartFontComponent = /*#__PURE__*/(() => {
  class DxoChartFontComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get family() {
      return this._getOption('family');
    }
    set family(value) {
      this._setOption('family', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    get _optionPath() {
      return 'font';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartFontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartFontComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartFontComponent,
      selectors: [["dxo-chart-font"]],
      inputs: {
        color: "color",
        family: "family",
        opacity: "opacity",
        size: "size",
        weight: "weight"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartFontComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartFontComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartFontModule = /*#__PURE__*/(() => {
  class DxoChartFontModule {
    /** @nocollapse */static ɵfac = function DxoChartFontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartFontModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartFontModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartFontComponent]
    });
  }
  return DxoChartFontModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartFormatComponent = /*#__PURE__*/(() => {
  class DxoChartFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartFormatComponent,
      selectors: [["dxo-chart-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartFormatModule = /*#__PURE__*/(() => {
  class DxoChartFormatModule {
    /** @nocollapse */static ɵfac = function DxoChartFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartFormatComponent]
    });
  }
  return DxoChartFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartGridComponent = /*#__PURE__*/(() => {
  class DxoChartGridComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'grid';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartGridComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartGridComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartGridComponent,
      selectors: [["dxo-chart-grid"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartGridComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartGridModule = /*#__PURE__*/(() => {
  class DxoChartGridModule {
    /** @nocollapse */static ɵfac = function DxoChartGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartGridModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartGridModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartGridComponent]
    });
  }
  return DxoChartGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartHatchingComponent = /*#__PURE__*/(() => {
  class DxoChartHatchingComponent extends NestedOption {
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get step() {
      return this._getOption('step');
    }
    set step(value) {
      this._setOption('step', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'hatching';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartHatchingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHatchingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartHatchingComponent,
      selectors: [["dxo-chart-hatching"]],
      inputs: {
        direction: "direction",
        opacity: "opacity",
        step: "step",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartHatchingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartHatchingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartHatchingModule = /*#__PURE__*/(() => {
  class DxoChartHatchingModule {
    /** @nocollapse */static ɵfac = function DxoChartHatchingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHatchingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartHatchingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartHatchingComponent]
    });
  }
  return DxoChartHatchingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartHeightComponent = /*#__PURE__*/(() => {
  class DxoChartHeightComponent extends NestedOption {
    get rangeMaxPoint() {
      return this._getOption('rangeMaxPoint');
    }
    set rangeMaxPoint(value) {
      this._setOption('rangeMaxPoint', value);
    }
    get rangeMinPoint() {
      return this._getOption('rangeMinPoint');
    }
    set rangeMinPoint(value) {
      this._setOption('rangeMinPoint', value);
    }
    get _optionPath() {
      return 'height';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartHeightComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHeightComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartHeightComponent,
      selectors: [["dxo-chart-height"]],
      inputs: {
        rangeMaxPoint: "rangeMaxPoint",
        rangeMinPoint: "rangeMinPoint"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartHeightComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartHeightComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartHeightModule = /*#__PURE__*/(() => {
  class DxoChartHeightModule {
    /** @nocollapse */static ɵfac = function DxoChartHeightModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHeightModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartHeightModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartHeightComponent]
    });
  }
  return DxoChartHeightModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartHorizontalLineLabelComponent = /*#__PURE__*/(() => {
  class DxoChartHorizontalLineLabelComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartHorizontalLineLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHorizontalLineLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartHorizontalLineLabelComponent,
      selectors: [["dxo-chart-horizontal-line-label"]],
      inputs: {
        backgroundColor: "backgroundColor",
        customizeText: "customizeText",
        font: "font",
        format: "format",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartHorizontalLineLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartHorizontalLineLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartHorizontalLineLabelModule = /*#__PURE__*/(() => {
  class DxoChartHorizontalLineLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartHorizontalLineLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHorizontalLineLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartHorizontalLineLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartHorizontalLineLabelComponent]
    });
  }
  return DxoChartHorizontalLineLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartHorizontalLineComponent = /*#__PURE__*/(() => {
  class DxoChartHorizontalLineComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'horizontalLine';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartHorizontalLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHorizontalLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartHorizontalLineComponent,
      selectors: [["dxo-chart-horizontal-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartHorizontalLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartHorizontalLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartHorizontalLineModule = /*#__PURE__*/(() => {
  class DxoChartHorizontalLineModule {
    /** @nocollapse */static ɵfac = function DxoChartHorizontalLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHorizontalLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartHorizontalLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartHorizontalLineComponent]
    });
  }
  return DxoChartHorizontalLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoChartHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartHoverStyleComponent,
      selectors: [["dxo-chart-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width",
        size: "size"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartHoverStyleModule = /*#__PURE__*/(() => {
  class DxoChartHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartHoverStyleComponent]
    });
  }
  return DxoChartHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartImageComponent = /*#__PURE__*/(() => {
  class DxoChartImageComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'image';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartImageComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartImageComponent,
      selectors: [["dxo-chart-image"]],
      inputs: {
        height: "height",
        url: "url",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartImageComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartImageModule = /*#__PURE__*/(() => {
  class DxoChartImageModule {
    /** @nocollapse */static ɵfac = function DxoChartImageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartImageModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartImageModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartImageComponent]
    });
  }
  return DxoChartImageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartLabelComponent = /*#__PURE__*/(() => {
  class DxoChartLabelComponent extends NestedOption {
    renderer;
    document;
    element;
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get staggeringSpacing() {
      return this._getOption('staggeringSpacing');
    }
    set staggeringSpacing(value) {
      this._setOption('staggeringSpacing', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get connector() {
      return this._getOption('connector');
    }
    set connector(value) {
      this._setOption('connector', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get horizontalOffset() {
      return this._getOption('horizontalOffset');
    }
    set horizontalOffset(value) {
      this._setOption('horizontalOffset', value);
    }
    get showForZeroValues() {
      return this._getOption('showForZeroValues');
    }
    set showForZeroValues(value) {
      this._setOption('showForZeroValues', value);
    }
    get verticalOffset() {
      return this._getOption('verticalOffset');
    }
    set verticalOffset(value) {
      this._setOption('verticalOffset', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartLabelComponent,
      selectors: [["dxo-chart-label"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        position: "position",
        verticalAlignment: "verticalAlignment",
        visible: "visible",
        text: "text",
        alignment: "alignment",
        customizeHint: "customizeHint",
        customizeText: "customizeText",
        displayMode: "displayMode",
        format: "format",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        rotationAngle: "rotationAngle",
        staggeringSpacing: "staggeringSpacing",
        template: "template",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap",
        argumentFormat: "argumentFormat",
        backgroundColor: "backgroundColor",
        border: "border",
        connector: "connector",
        displayFormat: "displayFormat",
        horizontalOffset: "horizontalOffset",
        showForZeroValues: "showForZeroValues",
        verticalOffset: "verticalOffset"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoChartLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoChartLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartLabelModule = /*#__PURE__*/(() => {
  class DxoChartLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartLabelComponent]
    });
  }
  return DxoChartLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartLegendTitleSubtitleComponent = /*#__PURE__*/(() => {
  class DxoChartLegendTitleSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartLegendTitleSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLegendTitleSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartLegendTitleSubtitleComponent,
      selectors: [["dxo-chart-legend-title-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartLegendTitleSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartLegendTitleSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartLegendTitleSubtitleModule = /*#__PURE__*/(() => {
  class DxoChartLegendTitleSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoChartLegendTitleSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLegendTitleSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartLegendTitleSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartLegendTitleSubtitleComponent]
    });
  }
  return DxoChartLegendTitleSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartLegendTitleComponent = /*#__PURE__*/(() => {
  class DxoChartLegendTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartLegendTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLegendTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartLegendTitleComponent,
      selectors: [["dxo-chart-legend-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        verticalAlignment: "verticalAlignment"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartLegendTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartLegendTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartLegendTitleModule = /*#__PURE__*/(() => {
  class DxoChartLegendTitleModule {
    /** @nocollapse */static ɵfac = function DxoChartLegendTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLegendTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartLegendTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartLegendTitleComponent]
    });
  }
  return DxoChartLegendTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartLegendComponent = /*#__PURE__*/(() => {
  class DxoChartLegendComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get columnCount() {
      return this._getOption('columnCount');
    }
    set columnCount(value) {
      this._setOption('columnCount', value);
    }
    get columnItemSpacing() {
      return this._getOption('columnItemSpacing');
    }
    set columnItemSpacing(value) {
      this._setOption('columnItemSpacing', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeItems() {
      return this._getOption('customizeItems');
    }
    set customizeItems(value) {
      this._setOption('customizeItems', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get itemsAlignment() {
      return this._getOption('itemsAlignment');
    }
    set itemsAlignment(value) {
      this._setOption('itemsAlignment', value);
    }
    get itemTextPosition() {
      return this._getOption('itemTextPosition');
    }
    set itemTextPosition(value) {
      this._setOption('itemTextPosition', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get markerSize() {
      return this._getOption('markerSize');
    }
    set markerSize(value) {
      this._setOption('markerSize', value);
    }
    get markerTemplate() {
      return this._getOption('markerTemplate');
    }
    set markerTemplate(value) {
      this._setOption('markerTemplate', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get rowCount() {
      return this._getOption('rowCount');
    }
    set rowCount(value) {
      this._setOption('rowCount', value);
    }
    get rowItemSpacing() {
      return this._getOption('rowItemSpacing');
    }
    set rowItemSpacing(value) {
      this._setOption('rowItemSpacing', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'legend';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartLegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLegendComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartLegendComponent,
      selectors: [["dxo-chart-legend"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        columnCount: "columnCount",
        columnItemSpacing: "columnItemSpacing",
        customizeHint: "customizeHint",
        customizeItems: "customizeItems",
        customizeText: "customizeText",
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        hoverMode: "hoverMode",
        itemsAlignment: "itemsAlignment",
        itemTextPosition: "itemTextPosition",
        margin: "margin",
        markerSize: "markerSize",
        markerTemplate: "markerTemplate",
        orientation: "orientation",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        position: "position",
        rowCount: "rowCount",
        rowItemSpacing: "rowItemSpacing",
        title: "title",
        verticalAlignment: "verticalAlignment",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartLegendComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartLegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartLegendModule = /*#__PURE__*/(() => {
  class DxoChartLegendModule {
    /** @nocollapse */static ɵfac = function DxoChartLegendModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLegendModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartLegendModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartLegendComponent]
    });
  }
  return DxoChartLegendModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartLengthComponent = /*#__PURE__*/(() => {
  class DxoChartLengthComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'length';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartLengthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLengthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartLengthComponent,
      selectors: [["dxo-chart-length"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartLengthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartLengthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartLengthModule = /*#__PURE__*/(() => {
  class DxoChartLengthModule {
    /** @nocollapse */static ɵfac = function DxoChartLengthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLengthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartLengthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartLengthComponent]
    });
  }
  return DxoChartLengthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class DxoChartLoadingIndicatorComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showChange;
    get _optionPath() {
      return 'loadingIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'showChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartLoadingIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartLoadingIndicatorComponent,
      selectors: [["dxo-chart-loading-indicator"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        font: "font",
        show: "show",
        text: "text"
      },
      outputs: {
        showChange: "showChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartLoadingIndicatorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartLoadingIndicatorModule = /*#__PURE__*/(() => {
  class DxoChartLoadingIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoChartLoadingIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartLoadingIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartLoadingIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartLoadingIndicatorComponent]
    });
  }
  return DxoChartLoadingIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartMarginComponent = /*#__PURE__*/(() => {
  class DxoChartMarginComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'margin';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartMarginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMarginComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartMarginComponent,
      selectors: [["dxo-chart-margin"]],
      inputs: {
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartMarginComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartMarginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartMarginModule = /*#__PURE__*/(() => {
  class DxoChartMarginModule {
    /** @nocollapse */static ɵfac = function DxoChartMarginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMarginModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartMarginModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartMarginComponent]
    });
  }
  return DxoChartMarginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartMinVisualRangeLengthComponent = /*#__PURE__*/(() => {
  class DxoChartMinVisualRangeLengthComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minVisualRangeLength';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartMinVisualRangeLengthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinVisualRangeLengthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartMinVisualRangeLengthComponent,
      selectors: [["dxo-chart-min-visual-range-length"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartMinVisualRangeLengthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartMinVisualRangeLengthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartMinVisualRangeLengthModule = /*#__PURE__*/(() => {
  class DxoChartMinVisualRangeLengthModule {
    /** @nocollapse */static ɵfac = function DxoChartMinVisualRangeLengthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinVisualRangeLengthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartMinVisualRangeLengthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartMinVisualRangeLengthComponent]
    });
  }
  return DxoChartMinVisualRangeLengthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartMinorGridComponent = /*#__PURE__*/(() => {
  class DxoChartMinorGridComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorGrid';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartMinorGridComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinorGridComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartMinorGridComponent,
      selectors: [["dxo-chart-minor-grid"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartMinorGridComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartMinorGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartMinorGridModule = /*#__PURE__*/(() => {
  class DxoChartMinorGridModule {
    /** @nocollapse */static ɵfac = function DxoChartMinorGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinorGridModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartMinorGridModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartMinorGridComponent]
    });
  }
  return DxoChartMinorGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartMinorTickIntervalComponent = /*#__PURE__*/(() => {
  class DxoChartMinorTickIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minorTickInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartMinorTickIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinorTickIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartMinorTickIntervalComponent,
      selectors: [["dxo-chart-minor-tick-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartMinorTickIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartMinorTickIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartMinorTickIntervalModule = /*#__PURE__*/(() => {
  class DxoChartMinorTickIntervalModule {
    /** @nocollapse */static ɵfac = function DxoChartMinorTickIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinorTickIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartMinorTickIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartMinorTickIntervalComponent]
    });
  }
  return DxoChartMinorTickIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartMinorTickComponent = /*#__PURE__*/(() => {
  class DxoChartMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartMinorTickComponent,
      selectors: [["dxo-chart-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartMinorTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartMinorTickModule = /*#__PURE__*/(() => {
  class DxoChartMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoChartMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartMinorTickComponent]
    });
  }
  return DxoChartMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartPaneBorderComponent = /*#__PURE__*/(() => {
  class DxoChartPaneBorderComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartPaneBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPaneBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartPaneBorderComponent,
      selectors: [["dxo-chart-pane-border"]],
      inputs: {
        bottom: "bottom",
        color: "color",
        dashStyle: "dashStyle",
        left: "left",
        opacity: "opacity",
        right: "right",
        top: "top",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartPaneBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartPaneBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartPaneBorderModule = /*#__PURE__*/(() => {
  class DxoChartPaneBorderModule {
    /** @nocollapse */static ɵfac = function DxoChartPaneBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPaneBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartPaneBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartPaneBorderComponent]
    });
  }
  return DxoChartPaneBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartPaneComponent = /*#__PURE__*/(() => {
  class DxiChartPaneComponent extends CollectionNestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'panes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartPaneComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartPaneComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartPaneComponent,
      selectors: [["dxi-chart-pane"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        height: "height",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_panes,
        useExisting: DxiChartPaneComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartPaneComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChartPaneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartPaneModule = /*#__PURE__*/(() => {
  class DxiChartPaneModule {
    /** @nocollapse */static ɵfac = function DxiChartPaneModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartPaneModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartPaneModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartPaneComponent]
    });
  }
  return DxiChartPaneModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartPointBorderComponent = /*#__PURE__*/(() => {
  class DxoChartPointBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartPointBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartPointBorderComponent,
      selectors: [["dxo-chart-point-border"]],
      inputs: {
        color: "color",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartPointBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartPointBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartPointBorderModule = /*#__PURE__*/(() => {
  class DxoChartPointBorderModule {
    /** @nocollapse */static ɵfac = function DxoChartPointBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartPointBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartPointBorderComponent]
    });
  }
  return DxoChartPointBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartPointHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoChartPointHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartPointHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartPointHoverStyleComponent,
      selectors: [["dxo-chart-point-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartPointHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartPointHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartPointHoverStyleModule = /*#__PURE__*/(() => {
  class DxoChartPointHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartPointHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartPointHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartPointHoverStyleComponent]
    });
  }
  return DxoChartPointHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartPointImageComponent = /*#__PURE__*/(() => {
  class DxoChartPointImageComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'image';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartPointImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointImageComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartPointImageComponent,
      selectors: [["dxo-chart-point-image"]],
      inputs: {
        height: "height",
        url: "url",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartPointImageComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartPointImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartPointImageModule = /*#__PURE__*/(() => {
  class DxoChartPointImageModule {
    /** @nocollapse */static ɵfac = function DxoChartPointImageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointImageModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartPointImageModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartPointImageComponent]
    });
  }
  return DxoChartPointImageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartPointSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoChartPointSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartPointSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartPointSelectionStyleComponent,
      selectors: [["dxo-chart-point-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartPointSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartPointSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartPointSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoChartPointSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartPointSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartPointSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartPointSelectionStyleComponent]
    });
  }
  return DxoChartPointSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartPointComponent = /*#__PURE__*/(() => {
  class DxoChartPointComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get symbol() {
      return this._getOption('symbol');
    }
    set symbol(value) {
      this._setOption('symbol', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'point';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartPointComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartPointComponent,
      selectors: [["dxo-chart-point"]],
      inputs: {
        border: "border",
        color: "color",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        image: "image",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        size: "size",
        symbol: "symbol",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartPointComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartPointComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartPointModule = /*#__PURE__*/(() => {
  class DxoChartPointModule {
    /** @nocollapse */static ɵfac = function DxoChartPointModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartPointModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartPointModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartPointComponent]
    });
  }
  return DxoChartPointModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartReductionComponent = /*#__PURE__*/(() => {
  class DxoChartReductionComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get level() {
      return this._getOption('level');
    }
    set level(value) {
      this._setOption('level', value);
    }
    get _optionPath() {
      return 'reduction';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartReductionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartReductionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartReductionComponent,
      selectors: [["dxo-chart-reduction"]],
      inputs: {
        color: "color",
        level: "level"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartReductionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartReductionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartReductionModule = /*#__PURE__*/(() => {
  class DxoChartReductionModule {
    /** @nocollapse */static ɵfac = function DxoChartReductionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartReductionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartReductionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartReductionComponent]
    });
  }
  return DxoChartReductionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartScrollBarComponent = /*#__PURE__*/(() => {
  class DxoChartScrollBarComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'scrollBar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartScrollBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartScrollBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartScrollBarComponent,
      selectors: [["dxo-chart-scroll-bar"]],
      inputs: {
        color: "color",
        offset: "offset",
        opacity: "opacity",
        position: "position",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartScrollBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartScrollBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartScrollBarModule = /*#__PURE__*/(() => {
  class DxoChartScrollBarModule {
    /** @nocollapse */static ɵfac = function DxoChartScrollBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartScrollBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartScrollBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartScrollBarComponent]
    });
  }
  return DxoChartScrollBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoChartSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartSelectionStyleComponent,
      selectors: [["dxo-chart-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoChartSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartSelectionStyleComponent]
    });
  }
  return DxoChartSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartSeriesBorderComponent = /*#__PURE__*/(() => {
  class DxoChartSeriesBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartSeriesBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSeriesBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartSeriesBorderComponent,
      selectors: [["dxo-chart-series-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartSeriesBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartSeriesBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartSeriesBorderModule = /*#__PURE__*/(() => {
  class DxoChartSeriesBorderModule {
    /** @nocollapse */static ɵfac = function DxoChartSeriesBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSeriesBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartSeriesBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartSeriesBorderComponent]
    });
  }
  return DxoChartSeriesBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartSeriesComponent = /*#__PURE__*/(() => {
  class DxiChartSeriesComponent extends CollectionNestedOption {
    get aggregation() {
      return this._getOption('aggregation');
    }
    set aggregation(value) {
      this._setOption('aggregation', value);
    }
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get barOverlapGroup() {
      return this._getOption('barOverlapGroup');
    }
    set barOverlapGroup(value) {
      this._setOption('barOverlapGroup', value);
    }
    get barPadding() {
      return this._getOption('barPadding');
    }
    set barPadding(value) {
      this._setOption('barPadding', value);
    }
    get barWidth() {
      return this._getOption('barWidth');
    }
    set barWidth(value) {
      this._setOption('barWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get closeValueField() {
      return this._getOption('closeValueField');
    }
    set closeValueField(value) {
      this._setOption('closeValueField', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get ignoreEmptyPoints() {
      return this._getOption('ignoreEmptyPoints');
    }
    set ignoreEmptyPoints(value) {
      this._setOption('ignoreEmptyPoints', value);
    }
    get innerColor() {
      return this._getOption('innerColor');
    }
    set innerColor(value) {
      this._setOption('innerColor', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minBarSize() {
      return this._getOption('minBarSize');
    }
    set minBarSize(value) {
      this._setOption('minBarSize', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get openValueField() {
      return this._getOption('openValueField');
    }
    set openValueField(value) {
      this._setOption('openValueField', value);
    }
    get pane() {
      return this._getOption('pane');
    }
    set pane(value) {
      this._setOption('pane', value);
    }
    get point() {
      return this._getOption('point');
    }
    set point(value) {
      this._setOption('point', value);
    }
    get rangeValue1Field() {
      return this._getOption('rangeValue1Field');
    }
    set rangeValue1Field(value) {
      this._setOption('rangeValue1Field', value);
    }
    get rangeValue2Field() {
      return this._getOption('rangeValue2Field');
    }
    set rangeValue2Field(value) {
      this._setOption('rangeValue2Field', value);
    }
    get reduction() {
      return this._getOption('reduction');
    }
    set reduction(value) {
      this._setOption('reduction', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get showInLegend() {
      return this._getOption('showInLegend');
    }
    set showInLegend(value) {
      this._setOption('showInLegend', value);
    }
    get sizeField() {
      return this._getOption('sizeField');
    }
    set sizeField(value) {
      this._setOption('sizeField', value);
    }
    get stack() {
      return this._getOption('stack');
    }
    set stack(value) {
      this._setOption('stack', value);
    }
    get tag() {
      return this._getOption('tag');
    }
    set tag(value) {
      this._setOption('tag', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueErrorBar() {
      return this._getOption('valueErrorBar');
    }
    set valueErrorBar(value) {
      this._setOption('valueErrorBar', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'series';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartSeriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartSeriesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartSeriesComponent,
      selectors: [["dxi-chart-series"]],
      inputs: {
        aggregation: "aggregation",
        argumentField: "argumentField",
        axis: "axis",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        name: "name",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        stack: "stack",
        tag: "tag",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_series,
        useExisting: DxiChartSeriesComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartSeriesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChartSeriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartSeriesModule = /*#__PURE__*/(() => {
  class DxiChartSeriesModule {
    /** @nocollapse */static ɵfac = function DxiChartSeriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartSeriesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartSeriesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartSeriesComponent]
    });
  }
  return DxiChartSeriesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartSeriesTemplateComponent = /*#__PURE__*/(() => {
  class DxoChartSeriesTemplateComponent extends NestedOption {
    get customizeSeries() {
      return this._getOption('customizeSeries');
    }
    set customizeSeries(value) {
      this._setOption('customizeSeries', value);
    }
    get nameField() {
      return this._getOption('nameField');
    }
    set nameField(value) {
      this._setOption('nameField', value);
    }
    get _optionPath() {
      return 'seriesTemplate';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartSeriesTemplateComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSeriesTemplateComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartSeriesTemplateComponent,
      selectors: [["dxo-chart-series-template"]],
      inputs: {
        customizeSeries: "customizeSeries",
        nameField: "nameField"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartSeriesTemplateComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartSeriesTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartSeriesTemplateModule = /*#__PURE__*/(() => {
  class DxoChartSeriesTemplateModule {
    /** @nocollapse */static ɵfac = function DxoChartSeriesTemplateModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSeriesTemplateModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartSeriesTemplateModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartSeriesTemplateComponent]
    });
  }
  return DxoChartSeriesTemplateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartShadowComponent = /*#__PURE__*/(() => {
  class DxoChartShadowComponent extends NestedOption {
    get blur() {
      return this._getOption('blur');
    }
    set blur(value) {
      this._setOption('blur', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shadow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartShadowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartShadowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartShadowComponent,
      selectors: [["dxo-chart-shadow"]],
      inputs: {
        blur: "blur",
        color: "color",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartShadowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartShadowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartShadowModule = /*#__PURE__*/(() => {
  class DxoChartShadowModule {
    /** @nocollapse */static ɵfac = function DxoChartShadowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartShadowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartShadowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartShadowComponent]
    });
  }
  return DxoChartShadowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartSizeComponent = /*#__PURE__*/(() => {
  class DxoChartSizeComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'size';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartSizeComponent,
      selectors: [["dxo-chart-size"]],
      inputs: {
        height: "height",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartSizeModule = /*#__PURE__*/(() => {
  class DxoChartSizeModule {
    /** @nocollapse */static ɵfac = function DxoChartSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartSizeComponent]
    });
  }
  return DxoChartSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartStripComponent = /*#__PURE__*/(() => {
  class DxiChartStripComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'strips';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartStripComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartStripComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartStripComponent,
      selectors: [["dxi-chart-strip"]],
      inputs: {
        color: "color",
        endValue: "endValue",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        startValue: "startValue"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_strips,
        useExisting: DxiChartStripComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartStripComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChartStripComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartStripModule = /*#__PURE__*/(() => {
  class DxiChartStripModule {
    /** @nocollapse */static ɵfac = function DxiChartStripModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartStripModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartStripModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartStripComponent]
    });
  }
  return DxiChartStripModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartStripLabelComponent = /*#__PURE__*/(() => {
  class DxoChartStripLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartStripLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartStripLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartStripLabelComponent,
      selectors: [["dxo-chart-strip-label"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        text: "text",
        verticalAlignment: "verticalAlignment"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartStripLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartStripLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartStripLabelModule = /*#__PURE__*/(() => {
  class DxoChartStripLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartStripLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartStripLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartStripLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartStripLabelComponent]
    });
  }
  return DxoChartStripLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartStripStyleLabelComponent = /*#__PURE__*/(() => {
  class DxoChartStripStyleLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartStripStyleLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartStripStyleLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartStripStyleLabelComponent,
      selectors: [["dxo-chart-strip-style-label"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        verticalAlignment: "verticalAlignment"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartStripStyleLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartStripStyleLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartStripStyleLabelModule = /*#__PURE__*/(() => {
  class DxoChartStripStyleLabelModule {
    /** @nocollapse */static ɵfac = function DxoChartStripStyleLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartStripStyleLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartStripStyleLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartStripStyleLabelComponent]
    });
  }
  return DxoChartStripStyleLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartStripStyleComponent = /*#__PURE__*/(() => {
  class DxoChartStripStyleComponent extends NestedOption {
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get _optionPath() {
      return 'stripStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartStripStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartStripStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartStripStyleComponent,
      selectors: [["dxo-chart-strip-style"]],
      inputs: {
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartStripStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartStripStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartStripStyleModule = /*#__PURE__*/(() => {
  class DxoChartStripStyleModule {
    /** @nocollapse */static ɵfac = function DxoChartStripStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartStripStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartStripStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartStripStyleComponent]
    });
  }
  return DxoChartStripStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartSubtitleComponent = /*#__PURE__*/(() => {
  class DxoChartSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartSubtitleComponent,
      selectors: [["dxo-chart-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartSubtitleModule = /*#__PURE__*/(() => {
  class DxoChartSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoChartSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartSubtitleComponent]
    });
  }
  return DxoChartSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartTickIntervalComponent = /*#__PURE__*/(() => {
  class DxoChartTickIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'tickInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartTickIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTickIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartTickIntervalComponent,
      selectors: [["dxo-chart-tick-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartTickIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartTickIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartTickIntervalModule = /*#__PURE__*/(() => {
  class DxoChartTickIntervalModule {
    /** @nocollapse */static ɵfac = function DxoChartTickIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTickIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartTickIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartTickIntervalComponent]
    });
  }
  return DxoChartTickIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartTickComponent = /*#__PURE__*/(() => {
  class DxoChartTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartTickComponent,
      selectors: [["dxo-chart-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartTickModule = /*#__PURE__*/(() => {
  class DxoChartTickModule {
    /** @nocollapse */static ɵfac = function DxoChartTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartTickComponent]
    });
  }
  return DxoChartTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartTitleComponent = /*#__PURE__*/(() => {
  class DxoChartTitleComponent extends NestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartTitleComponent,
      selectors: [["dxo-chart-title"]],
      inputs: {
        alignment: "alignment",
        font: "font",
        margin: "margin",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap",
        horizontalAlignment: "horizontalAlignment",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        verticalAlignment: "verticalAlignment"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartTitleModule = /*#__PURE__*/(() => {
  class DxoChartTitleModule {
    /** @nocollapse */static ɵfac = function DxoChartTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartTitleComponent]
    });
  }
  return DxoChartTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartTooltipBorderComponent = /*#__PURE__*/(() => {
  class DxoChartTooltipBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartTooltipBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTooltipBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartTooltipBorderComponent,
      selectors: [["dxo-chart-tooltip-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartTooltipBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartTooltipBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartTooltipBorderModule = /*#__PURE__*/(() => {
  class DxoChartTooltipBorderModule {
    /** @nocollapse */static ɵfac = function DxoChartTooltipBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTooltipBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartTooltipBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartTooltipBorderComponent]
    });
  }
  return DxoChartTooltipBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartTooltipComponent = /*#__PURE__*/(() => {
  class DxoChartTooltipComponent extends NestedOption {
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get interactive() {
      return this._getOption('interactive');
    }
    set interactive(value) {
      this._setOption('interactive', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get shared() {
      return this._getOption('shared');
    }
    set shared(value) {
      this._setOption('shared', value);
    }
    get zIndex() {
      return this._getOption('zIndex');
    }
    set zIndex(value) {
      this._setOption('zIndex', value);
    }
    get _optionPath() {
      return 'tooltip';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTooltipComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartTooltipComponent,
      selectors: [["dxo-chart-tooltip"]],
      inputs: {
        argumentFormat: "argumentFormat",
        arrowLength: "arrowLength",
        border: "border",
        color: "color",
        container: "container",
        contentTemplate: "contentTemplate",
        cornerRadius: "cornerRadius",
        customizeTooltip: "customizeTooltip",
        enabled: "enabled",
        font: "font",
        format: "format",
        interactive: "interactive",
        location: "location",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        shadow: "shadow",
        shared: "shared",
        zIndex: "zIndex"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartTooltipComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartTooltipModule = /*#__PURE__*/(() => {
  class DxoChartTooltipModule {
    /** @nocollapse */static ɵfac = function DxoChartTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartTooltipModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartTooltipModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartTooltipComponent]
    });
  }
  return DxoChartTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartUrlComponent = /*#__PURE__*/(() => {
  class DxoChartUrlComponent extends NestedOption {
    get rangeMaxPoint() {
      return this._getOption('rangeMaxPoint');
    }
    set rangeMaxPoint(value) {
      this._setOption('rangeMaxPoint', value);
    }
    get rangeMinPoint() {
      return this._getOption('rangeMinPoint');
    }
    set rangeMinPoint(value) {
      this._setOption('rangeMinPoint', value);
    }
    get _optionPath() {
      return 'url';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartUrlComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartUrlComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartUrlComponent,
      selectors: [["dxo-chart-url"]],
      inputs: {
        rangeMaxPoint: "rangeMaxPoint",
        rangeMinPoint: "rangeMinPoint"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartUrlComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartUrlComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartUrlModule = /*#__PURE__*/(() => {
  class DxoChartUrlModule {
    /** @nocollapse */static ɵfac = function DxoChartUrlModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartUrlModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartUrlModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartUrlComponent]
    });
  }
  return DxoChartUrlModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartValueAxisComponent = /*#__PURE__*/(() => {
  class DxiChartValueAxisComponent extends CollectionNestedOption {
    set _breaksContentChildren(value) {
      this.setChildren('breaks', value);
    }
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get aggregatedPointsPosition() {
      return this._getOption('aggregatedPointsPosition');
    }
    set aggregatedPointsPosition(value) {
      this._setOption('aggregatedPointsPosition', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get autoBreaksEnabled() {
      return this._getOption('autoBreaksEnabled');
    }
    set autoBreaksEnabled(value) {
      this._setOption('autoBreaksEnabled', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get breaks() {
      return this._getOption('breaks');
    }
    set breaks(value) {
      this._setOption('breaks', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get customPosition() {
      return this._getOption('customPosition');
    }
    set customPosition(value) {
      this._setOption('customPosition', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get maxAutoBreakCount() {
      return this._getOption('maxAutoBreakCount');
    }
    set maxAutoBreakCount(value) {
      this._setOption('maxAutoBreakCount', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get minVisualRangeLength() {
      return this._getOption('minVisualRangeLength');
    }
    set minVisualRangeLength(value) {
      this._setOption('minVisualRangeLength', value);
    }
    get multipleAxesSpacing() {
      return this._getOption('multipleAxesSpacing');
    }
    set multipleAxesSpacing(value) {
      this._setOption('multipleAxesSpacing', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get pane() {
      return this._getOption('pane');
    }
    set pane(value) {
      this._setOption('pane', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get showZero() {
      return this._getOption('showZero');
    }
    set showZero(value) {
      this._setOption('showZero', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get synchronizedValue() {
      return this._getOption('synchronizedValue');
    }
    set synchronizedValue(value) {
      this._setOption('synchronizedValue', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get valueType() {
      return this._getOption('valueType');
    }
    set valueType(value) {
      this._setOption('valueType', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visualRange() {
      return this._getOption('visualRange');
    }
    set visualRange(value) {
      this._setOption('visualRange', value);
    }
    get visualRangeUpdateMode() {
      return this._getOption('visualRangeUpdateMode');
    }
    set visualRangeUpdateMode(value) {
      this._setOption('visualRangeUpdateMode', value);
    }
    get wholeRange() {
      return this._getOption('wholeRange');
    }
    set wholeRange(value) {
      this._setOption('wholeRange', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    categoriesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visualRangeChange;
    get _optionPath() {
      return 'valueAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'categoriesChange'
      }, {
        emit: 'visualRangeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChartValueAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartValueAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartValueAxisComponent,
      selectors: [["dxi-chart-value-axis"]],
      contentQueries: function DxiChartValueAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_breaks, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._breaksContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        aggregatedPointsPosition: "aggregatedPointsPosition",
        allowDecimals: "allowDecimals",
        autoBreaksEnabled: "autoBreaksEnabled",
        axisDivisionFactor: "axisDivisionFactor",
        breaks: "breaks",
        breakStyle: "breakStyle",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        customPosition: "customPosition",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        maxAutoBreakCount: "maxAutoBreakCount",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        minValueMargin: "minValueMargin",
        minVisualRangeLength: "minVisualRangeLength",
        multipleAxesSpacing: "multipleAxesSpacing",
        name: "name",
        offset: "offset",
        opacity: "opacity",
        pane: "pane",
        placeholderSize: "placeholderSize",
        position: "position",
        showZero: "showZero",
        strips: "strips",
        stripStyle: "stripStyle",
        synchronizedValue: "synchronizedValue",
        tick: "tick",
        tickInterval: "tickInterval",
        title: "title",
        type: "type",
        valueMarginsEnabled: "valueMarginsEnabled",
        valueType: "valueType",
        visible: "visible",
        visualRange: "visualRange",
        visualRangeUpdateMode: "visualRangeUpdateMode",
        wholeRange: "wholeRange",
        width: "width"
      },
      outputs: {
        categoriesChange: "categoriesChange",
        visualRangeChange: "visualRangeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_valueAxis,
        useExisting: DxiChartValueAxisComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartValueAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChartValueAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChartValueAxisModule = /*#__PURE__*/(() => {
  class DxiChartValueAxisModule {
    /** @nocollapse */static ɵfac = function DxiChartValueAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChartValueAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChartValueAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChartValueAxisComponent]
    });
  }
  return DxiChartValueAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartValueErrorBarComponent = /*#__PURE__*/(() => {
  class DxoChartValueErrorBarComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get edgeLength() {
      return this._getOption('edgeLength');
    }
    set edgeLength(value) {
      this._setOption('edgeLength', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get lineWidth() {
      return this._getOption('lineWidth');
    }
    set lineWidth(value) {
      this._setOption('lineWidth', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get _optionPath() {
      return 'valueErrorBar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartValueErrorBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartValueErrorBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartValueErrorBarComponent,
      selectors: [["dxo-chart-value-error-bar"]],
      inputs: {
        color: "color",
        displayMode: "displayMode",
        edgeLength: "edgeLength",
        highValueField: "highValueField",
        lineWidth: "lineWidth",
        lowValueField: "lowValueField",
        opacity: "opacity",
        type: "type",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartValueErrorBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartValueErrorBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartValueErrorBarModule = /*#__PURE__*/(() => {
  class DxoChartValueErrorBarModule {
    /** @nocollapse */static ɵfac = function DxoChartValueErrorBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartValueErrorBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartValueErrorBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartValueErrorBarComponent]
    });
  }
  return DxoChartValueErrorBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartVerticalLineComponent = /*#__PURE__*/(() => {
  class DxoChartVerticalLineComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'verticalLine';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartVerticalLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartVerticalLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartVerticalLineComponent,
      selectors: [["dxo-chart-vertical-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartVerticalLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartVerticalLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartVerticalLineModule = /*#__PURE__*/(() => {
  class DxoChartVerticalLineModule {
    /** @nocollapse */static ɵfac = function DxoChartVerticalLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartVerticalLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartVerticalLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartVerticalLineComponent]
    });
  }
  return DxoChartVerticalLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartVisualRangeComponent = /*#__PURE__*/(() => {
  class DxoChartVisualRangeComponent extends NestedOption {
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    endValueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    startValueChange;
    get _optionPath() {
      return 'visualRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'endValueChange'
      }, {
        emit: 'startValueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartVisualRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartVisualRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartVisualRangeComponent,
      selectors: [["dxo-chart-visual-range"]],
      inputs: {
        endValue: "endValue",
        length: "length",
        startValue: "startValue"
      },
      outputs: {
        endValueChange: "endValueChange",
        startValueChange: "startValueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartVisualRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartVisualRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartVisualRangeModule = /*#__PURE__*/(() => {
  class DxoChartVisualRangeModule {
    /** @nocollapse */static ɵfac = function DxoChartVisualRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartVisualRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartVisualRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartVisualRangeComponent]
    });
  }
  return DxoChartVisualRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartWholeRangeComponent = /*#__PURE__*/(() => {
  class DxoChartWholeRangeComponent extends NestedOption {
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    endValueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    startValueChange;
    get _optionPath() {
      return 'wholeRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'endValueChange'
      }, {
        emit: 'startValueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartWholeRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartWholeRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartWholeRangeComponent,
      selectors: [["dxo-chart-whole-range"]],
      inputs: {
        endValue: "endValue",
        length: "length",
        startValue: "startValue"
      },
      outputs: {
        endValueChange: "endValueChange",
        startValueChange: "startValueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartWholeRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartWholeRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartWholeRangeModule = /*#__PURE__*/(() => {
  class DxoChartWholeRangeModule {
    /** @nocollapse */static ɵfac = function DxoChartWholeRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartWholeRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartWholeRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartWholeRangeComponent]
    });
  }
  return DxoChartWholeRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartWidthComponent = /*#__PURE__*/(() => {
  class DxoChartWidthComponent extends NestedOption {
    get rangeMaxPoint() {
      return this._getOption('rangeMaxPoint');
    }
    set rangeMaxPoint(value) {
      this._setOption('rangeMaxPoint', value);
    }
    get rangeMinPoint() {
      return this._getOption('rangeMinPoint');
    }
    set rangeMinPoint(value) {
      this._setOption('rangeMinPoint', value);
    }
    get _optionPath() {
      return 'width';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartWidthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartWidthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartWidthComponent,
      selectors: [["dxo-chart-width"]],
      inputs: {
        rangeMaxPoint: "rangeMaxPoint",
        rangeMinPoint: "rangeMinPoint"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartWidthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartWidthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartWidthModule = /*#__PURE__*/(() => {
  class DxoChartWidthModule {
    /** @nocollapse */static ɵfac = function DxoChartWidthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartWidthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartWidthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartWidthComponent]
    });
  }
  return DxoChartWidthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartZoomAndPanComponent = /*#__PURE__*/(() => {
  class DxoChartZoomAndPanComponent extends NestedOption {
    get allowMouseWheel() {
      return this._getOption('allowMouseWheel');
    }
    set allowMouseWheel(value) {
      this._setOption('allowMouseWheel', value);
    }
    get allowTouchGestures() {
      return this._getOption('allowTouchGestures');
    }
    set allowTouchGestures(value) {
      this._setOption('allowTouchGestures', value);
    }
    get argumentAxis() {
      return this._getOption('argumentAxis');
    }
    set argumentAxis(value) {
      this._setOption('argumentAxis', value);
    }
    get dragBoxStyle() {
      return this._getOption('dragBoxStyle');
    }
    set dragBoxStyle(value) {
      this._setOption('dragBoxStyle', value);
    }
    get dragToZoom() {
      return this._getOption('dragToZoom');
    }
    set dragToZoom(value) {
      this._setOption('dragToZoom', value);
    }
    get panKey() {
      return this._getOption('panKey');
    }
    set panKey(value) {
      this._setOption('panKey', value);
    }
    get valueAxis() {
      return this._getOption('valueAxis');
    }
    set valueAxis(value) {
      this._setOption('valueAxis', value);
    }
    get _optionPath() {
      return 'zoomAndPan';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartZoomAndPanComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartZoomAndPanComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartZoomAndPanComponent,
      selectors: [["dxo-chart-zoom-and-pan"]],
      inputs: {
        allowMouseWheel: "allowMouseWheel",
        allowTouchGestures: "allowTouchGestures",
        argumentAxis: "argumentAxis",
        dragBoxStyle: "dragBoxStyle",
        dragToZoom: "dragToZoom",
        panKey: "panKey",
        valueAxis: "valueAxis"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartZoomAndPanComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartZoomAndPanComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartZoomAndPanModule = /*#__PURE__*/(() => {
  class DxoChartZoomAndPanModule {
    /** @nocollapse */static ɵfac = function DxoChartZoomAndPanModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartZoomAndPanModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartZoomAndPanModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartZoomAndPanComponent]
    });
  }
  return DxoChartZoomAndPanModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiChartAnnotationComponent, DxiChartAnnotationModule, DxiChartBreakComponent, DxiChartBreakModule, DxiChartConstantLineComponent, DxiChartConstantLineModule, DxiChartPaneComponent, DxiChartPaneModule, DxiChartSeriesComponent, DxiChartSeriesModule, DxiChartStripComponent, DxiChartStripModule, DxiChartValueAxisComponent, DxiChartValueAxisModule, DxoChartAdaptiveLayoutComponent, DxoChartAdaptiveLayoutModule, DxoChartAggregationComponent, DxoChartAggregationIntervalComponent, DxoChartAggregationIntervalModule, DxoChartAggregationModule, DxoChartAnimationComponent, DxoChartAnimationModule, DxoChartAnnotationBorderComponent, DxoChartAnnotationBorderModule, DxoChartAnnotationImageComponent, DxoChartAnnotationImageModule, DxoChartArgumentAxisComponent, DxoChartArgumentAxisModule, DxoChartArgumentFormatComponent, DxoChartArgumentFormatModule, DxoChartAxisConstantLineStyleComponent, DxoChartAxisConstantLineStyleLabelComponent, DxoChartAxisConstantLineStyleLabelModule, DxoChartAxisConstantLineStyleModule, DxoChartAxisLabelComponent, DxoChartAxisLabelModule, DxoChartAxisTitleComponent, DxoChartAxisTitleModule, DxoChartBackgroundColorComponent, DxoChartBackgroundColorModule, DxoChartBorderComponent, DxoChartBorderModule, DxoChartBreakStyleComponent, DxoChartBreakStyleModule, DxoChartChartTitleComponent, DxoChartChartTitleModule, DxoChartChartTitleSubtitleComponent, DxoChartChartTitleSubtitleModule, DxoChartColorComponent, DxoChartColorModule, DxoChartCommonAnnotationSettingsComponent, DxoChartCommonAnnotationSettingsModule, DxoChartCommonAxisSettingsComponent, DxoChartCommonAxisSettingsConstantLineStyleComponent, DxoChartCommonAxisSettingsConstantLineStyleLabelComponent, DxoChartCommonAxisSettingsConstantLineStyleLabelModule, DxoChartCommonAxisSettingsConstantLineStyleModule, DxoChartCommonAxisSettingsLabelComponent, DxoChartCommonAxisSettingsLabelModule, DxoChartCommonAxisSettingsModule, DxoChartCommonAxisSettingsTitleComponent, DxoChartCommonAxisSettingsTitleModule, DxoChartCommonPaneSettingsComponent, DxoChartCommonPaneSettingsModule, DxoChartCommonSeriesSettingsComponent, DxoChartCommonSeriesSettingsHoverStyleComponent, DxoChartCommonSeriesSettingsHoverStyleModule, DxoChartCommonSeriesSettingsLabelComponent, DxoChartCommonSeriesSettingsLabelModule, DxoChartCommonSeriesSettingsModule, DxoChartCommonSeriesSettingsSelectionStyleComponent, DxoChartCommonSeriesSettingsSelectionStyleModule, DxoChartConnectorComponent, DxoChartConnectorModule, DxoChartConstantLineLabelComponent, DxoChartConstantLineLabelModule, DxoChartConstantLineStyleComponent, DxoChartConstantLineStyleModule, DxoChartCrosshairComponent, DxoChartCrosshairModule, DxoChartDataPrepareSettingsComponent, DxoChartDataPrepareSettingsModule, DxoChartDragBoxStyleComponent, DxoChartDragBoxStyleModule, DxoChartExportComponent, DxoChartExportModule, DxoChartFontComponent, DxoChartFontModule, DxoChartFormatComponent, DxoChartFormatModule, DxoChartGridComponent, DxoChartGridModule, DxoChartHatchingComponent, DxoChartHatchingModule, DxoChartHeightComponent, DxoChartHeightModule, DxoChartHorizontalLineComponent, DxoChartHorizontalLineLabelComponent, DxoChartHorizontalLineLabelModule, DxoChartHorizontalLineModule, DxoChartHoverStyleComponent, DxoChartHoverStyleModule, DxoChartImageComponent, DxoChartImageModule, DxoChartLabelComponent, DxoChartLabelModule, DxoChartLegendComponent, DxoChartLegendModule, DxoChartLegendTitleComponent, DxoChartLegendTitleModule, DxoChartLegendTitleSubtitleComponent, DxoChartLegendTitleSubtitleModule, DxoChartLengthComponent, DxoChartLengthModule, DxoChartLoadingIndicatorComponent, DxoChartLoadingIndicatorModule, DxoChartMarginComponent, DxoChartMarginModule, DxoChartMinVisualRangeLengthComponent, DxoChartMinVisualRangeLengthModule, DxoChartMinorGridComponent, DxoChartMinorGridModule, DxoChartMinorTickComponent, DxoChartMinorTickIntervalComponent, DxoChartMinorTickIntervalModule, DxoChartMinorTickModule, DxoChartPaneBorderComponent, DxoChartPaneBorderModule, DxoChartPointBorderComponent, DxoChartPointBorderModule, DxoChartPointComponent, DxoChartPointHoverStyleComponent, DxoChartPointHoverStyleModule, DxoChartPointImageComponent, DxoChartPointImageModule, DxoChartPointModule, DxoChartPointSelectionStyleComponent, DxoChartPointSelectionStyleModule, DxoChartReductionComponent, DxoChartReductionModule, DxoChartScrollBarComponent, DxoChartScrollBarModule, DxoChartSelectionStyleComponent, DxoChartSelectionStyleModule, DxoChartSeriesBorderComponent, DxoChartSeriesBorderModule, DxoChartSeriesTemplateComponent, DxoChartSeriesTemplateModule, DxoChartShadowComponent, DxoChartShadowModule, DxoChartSizeComponent, DxoChartSizeModule, DxoChartStripLabelComponent, DxoChartStripLabelModule, DxoChartStripStyleComponent, DxoChartStripStyleLabelComponent, DxoChartStripStyleLabelModule, DxoChartStripStyleModule, DxoChartSubtitleComponent, DxoChartSubtitleModule, DxoChartTickComponent, DxoChartTickIntervalComponent, DxoChartTickIntervalModule, DxoChartTickModule, DxoChartTitleComponent, DxoChartTitleModule, DxoChartTooltipBorderComponent, DxoChartTooltipBorderModule, DxoChartTooltipComponent, DxoChartTooltipModule, DxoChartUrlComponent, DxoChartUrlModule, DxoChartValueErrorBarComponent, DxoChartValueErrorBarModule, DxoChartVerticalLineComponent, DxoChartVerticalLineModule, DxoChartVisualRangeComponent, DxoChartVisualRangeModule, DxoChartWholeRangeComponent, DxoChartWholeRangeModule, DxoChartWidthComponent, DxoChartWidthModule, DxoChartZoomAndPanComponent, DxoChartZoomAndPanModule };
